/* eslint-disable @repo/internal/react/require-jsdoc */
import React, { useRef } from 'react';

import { Video } from '@af/design-system-docs-ui';

export const HoverActivatedVideo = ({ src, poster }: { src: string; poster: string }) => {
	const ref = useRef<HTMLVideoElement>(null);

	const onMouseEnter = () => {
		if (!ref.current) {
			return;
		}
		ref.current?.play();
	};

	const onMouseLeave = () => {
		if (!ref.current) {
			return;
		}

		ref.current.pause();
		ref.current.currentTime = 0;
	};

	return (
		<Video
			ref={ref}
			src={src}
			poster={poster}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
		/>
	);
};
